<template>
    <b-sidebar id="sidebar--customer-notes"
               backdrop-variant="dark"
               backdrop
               :visible="isSidebarOpen"
               right
               shadow
               no-close-on-backdrop
               no-close-on-esc
               no-header-close>
        <b-form class="d-block px-2" @submit.prevent="onSave">
            <b-form-group id="sidebar--customer-notes-form-group"
                          label="Anteckningar"
                          label-for="sidebar--customer-notes-form"
                          label-class="text-center">
                <b-form-textarea id="sidebar--customer-notes-form"
                                 v-model="localNotes"
                                 rows="8" />
            </b-form-group>

            <div class="d-flex mt-3 justify-content-between">
                <b-button variant="warning" @click="onClose">
                    Stäng
                </b-button>
                <b-button variant="success" type="submit">
                    Spara
                </b-button>
            </div>
        </b-form>
    </b-sidebar>
</template>

<script>
    import { get } from '@/helpers/api';

    export default {
        name: 'CustomerNotesSidebar',
        props: {
            customerId: {
                type: [String, Number],
                default: null
            },
            canReadNotes: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isSidebarOpen: false,
                localNotes: ''
            };
        },
        watch: {
            customerId: {
                immediate: true,
                async handler(customerId) {
                    await this.loadNotes(customerId);
                }
            }
        },
        methods: {
            async loadNotes(customerId) {
                if (!this.canReadNotes || !customerId) {
                    this.localNotes = '';
                    this.$emit('notes-loaded', '');
                    return;
                }

                try {
                    const response = await get('Customer', `GetNotes?id=${customerId}`);
                    const notes = response.data && response.data.notes ? response.data.notes : '';

                    this.localNotes = notes;
                    this.$emit('notes-loaded', notes);
                } catch (e) {
                    this.localNotes = '';
                    this.$emit('notes-loaded', '');
                }
            },
            open() {
                this.isSidebarOpen = true;
            },
            onClose() {
                this.isSidebarOpen = false;
            },
            onSave() {
                this.$emit('save', this.localNotes);
                this.$emit('notes-loaded', this.localNotes);
                this.isSidebarOpen = false;
            }
        }
    };
</script>
<style scoped>
    #sidebar--customer-notes-form {
        height: 50vh;
    }
</style>